export enum MesEnum {
  JANEIRO = 'JANEIRO',
  FEVEREIRO = 'FEVEREIRO',
  MARCO = 'MARCO',
  ABRIL = 'ABRIL',
  MAIO = 'MAIO',
  JUNHO = 'JUNHO',
  JULHO = 'JULHO',
  AGOSTO = 'AGOSTO',
  SETEMBRO = 'SETEMBRO',
  OUTUBRO = 'OUTUBRO',
  NOVEMBRO = 'NOVEMBRO',
  DEZEMBRO = 'DEZEMBRO'
}

export const MesEnumFormatado = {
  JANEIRO: 'Janeiro',
  FEVEREIRO: 'Fevereiro',
  MARCO: 'Março',
  ABRIL: 'Abril',
  MAIO: 'Maio',
  JUNHO: 'Junho',
  JULHO: 'Julho',
  AGOSTO: 'Agosto',
  SETEMBRO: 'Setembro',
  OUTUBRO: 'Outubro',
  NOVEMBRO: 'Novembro',
  DEZEMBRO: 'Dezembro'
};

export const MesEnumValues = {
  JANEIRO: 1,
  FEVEREIRO: 2,
  MARCO: 3,
  ABRIL: 4,
  MAIO: 5,
  JUNHO: 6,
  JULHO: 7,
  AGOSTO: 8,
  SETEMBRO: 9,
  OUTUBRO: 10,
  NOVEMBRO: 11,
  DEZEMBRO: 12
};

export const MesEnumFormatadoFromValue = {
  1: 'Janeiro',
  2: 'Fevereiro',
  3: 'Março',
  4: 'Abril',
  5: 'Maio',
  6: 'Junho',
  7: 'Julho',
  8: 'Agosto',
  9: 'Setembro',
  10: 'Outubro',
  11: 'Novembro',
  12: 'Dezembro'
};
